module.exports = __webpack_public_path__ + "static/img/14.561d807.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tiankeng/14.jpg
// module id = YATV
// module chunks = 1